import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import { FiTrendingUp } from 'react-icons/fi';
import NodeWrapper from './NodeWrapper';
import { VISUAL_NODE_HEIGHT_CLASS } from '../layoutConfig';
import { getNodeAccent } from '../config/nodeVisualConfig';

const AreaChartNode = memo(({ data, selected }) => {
  const accent = getNodeAccent('area_node', data);
  return (
    <NodeWrapper
        selected={selected}
        title="Area Chart"
        type="VISUALIZATION"
        accent={accent}
        icon={FiTrendingUp}
        className={`${VISUAL_NODE_HEIGHT_CLASS} flex flex-col`}
        isHighlighted={data.isHighlighted}
    >
        {/* Input: Data Source */}
        <Handle
            type="target"
            id="input_0"
            position={Position.Left}
            className="!w-2.5 !h-2.5 !border-2 !border-[var(--bg-2)] transition-transform hover:scale-125"
            style={{ background: accent }}
        />

        <div className="space-y-2">
            <div className="w-full h-8 rounded relative overflow-hidden bg-bg-3 border border-[var(--divider)]">
                <div
                    className="absolute inset-0 opacity-50"
                    style={{
                        background: `linear-gradient(to bottom, ${data.topColor || 'rgba(41, 98, 255, 0.5)'}, ${data.bottomColor || 'rgba(41, 98, 255, 0.0)'})`
                    }}
                ></div>
                <div
                    className="absolute top-0 w-full h-0.5"
                    style={{ backgroundColor: data.lineColor || '#2962FF' }}
                ></div>
            </div>
        </div>

        {/* Output: Configuration Source — accent-tinted */}
        <Handle
            type="source"
            position={Position.Right}
            className="!w-2.5 !h-2.5 !border-2 !border-[var(--bg-2)] transition-transform hover:scale-125"
            style={{ background: accent }}
        />
    </NodeWrapper>
  );
});

export default AreaChartNode;
